import React from "react";

interface CloseButtonProps {
	classes?: string;
	label?: string;
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export function CloseButton({
	classes = "btn btn--primary",
	label = "Close",
	onClick,
}: CloseButtonProps) {
	return (
		<button type="button" className={classes} onClick={onClick}>
			{label}
		</button>
	);
}
